import { Text } from "react_reusable_components";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import Styles from "./productCategoryListingContainer.module.scss";

export const columns = (intl, isMobile) => [
  {
    dataIndex: "productCategoryName",
    title: (
      <Text className={Styles["header-text"]}>
        {getLocalizedMessage(intl, "productCategory.columnOneHeading")}
      </Text>
    ),
    width: isMobile ? "22%" : "20%",
    render: (text) => (
      <Text type="secondary" className={Styles["text-style"]}>
        {text}
      </Text>
    ),
  },
  {
    dataIndex: "subCategory",
    title: (
      <Text className={Styles["header-text"]}>
        {getLocalizedMessage(intl, "productCategory.columnTwoHeading")}
      </Text>
    ),
    width: isMobile ? "70%" : "77%",
    render: (text) => (
      <Text
        type="secondary"
        className={`${Styles["text-style"]} ${Styles["ellipsis-style"]}`}
      >
        {text
          ?.map((tagItem) => {
            return tagItem.name;
          })
          .join(" | ", "")}
      </Text>
    ),
  },
];
